import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96b95cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pt-20 editor-content",
  style: {"padding":"15px"}
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1711449105075",
  class: "icon",
  viewBox: "0 0 1039 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6851",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M559.246704 939.148776h-308.549906c-84.851224 0-154.274953-69.423729-154.274952-154.274953v-539.962335c0-84.851224 69.423729-154.274953 154.274952-154.274953h308.549906c84.851224 0 154.274953 69.423729 154.274953 154.274953v9.642184c0 21.212806-17.355932 38.568738-38.568738 38.568739s-38.568738-17.355932-38.568738-38.568739v-9.642184c0-42.425612-34.711864-77.137476-77.137477-77.137477h-308.549906c-42.425612 0-77.137476 34.711864-77.137476 77.137477v539.962335c0 42.425612 34.711864 77.137476 77.137476 77.137476h308.549906c42.425612 0 77.137476-34.711864 77.137477-77.137476v-3.856874c0-21.212806 17.355932-38.568738 38.568738-38.568738s38.568738 17.355932 38.568738 38.568738v3.856874c0 84.851224-69.423729 154.274953-154.274953 154.274953z",
    fill: "#388CEB",
    "p-id": "6852"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M840.798493 553.461394H520.677966c-21.212806 0-38.568738-17.355932-38.568738-38.568739s17.355932-38.568738 38.568738-38.568738h320.120527c21.212806 0 38.568738 17.355932 38.568739 38.568738s-17.355932 38.568738-38.568739 38.568739z",
    fill: "#E78E00",
    "p-id": "6853"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M752.090395 740.519774c-9.642185 0-19.284369-3.856874-25.069679-9.642185-15.427495-13.499058-17.355932-38.568738-3.856874-53.996233l142.704331-160.060264 1.928437-1.928437-1.928437-1.928437-146.561205-163.917137c-13.499058-15.427495-13.499058-40.497175 3.856874-53.996234 15.427495-13.499058 40.497175-13.499058 53.996233 3.856874l144.632769 161.988701c28.926554 28.926554 28.926554 77.137476 0 106.06403l-142.704332 160.060264c-5.785311 9.642185-17.355932 13.499058-26.998117 13.499058z",
    fill: "#E78E00",
    "p-id": "6854"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "title-top d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "module-title"
}
const _hoisted_7 = {
  key: 1,
  class: "module-title"
}
const _hoisted_8 = {
  key: 2,
  class: "module-title"
}
const _hoisted_9 = { style: {"margin-right":"15px"} }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = {
  key: 2,
  class: "d-flex align-items-center justify-content--center",
  style: {"height":"300px","text-align":"center"}
}
const _hoisted_12 = {
  key: 1,
  style: {"min-height":"300px"}
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("修改工单")
const _hoisted_15 = {
  key: 0,
  class: "mb-10 font-14"
}
const _hoisted_16 = { class: "d-flex align-items-center mb-20" }
const _hoisted_17 = { style: {"line-height":"32px"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 处理人 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("转发")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("接受&处理")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("退回修改")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("拒绝工单")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("修改工单")
const _hoisted_25 = { class: "mb-10 font-14" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("已解决")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("未解决")
const _hoisted_28 = { class: "bg-f5f7fa pt-10 pb-10" }
const _hoisted_29 = {
  class: "mb-10",
  style: {"width":"80%"}
}
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-10 font-14" }, "评论", -1))
const _hoisted_32 = {
  style: {"text-align":"right"},
  class: "mt-10"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("保存评论")
const _hoisted_34 = { class: "mb-5" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 1,
  style: {"min-height":"400px"}
}


const __default__ = {
    name:"TicketDetail"
}
import {ref, reactive, computed, onBeforeMount, nextTick, onMounted,shallowRef, onBeforeUnmount} from 'vue'
import {ElMessage, ElMessageBox, genFileId} from 'element-plus'
import { Back, DArrowLeft,Check,Close} from '@element-plus/icons-vue'
import '@wangeditor/editor/dist/css/style.css'
import { exportHandle } from '@/utils/index'
import "@wangeditor/editor/dist/css/style.css";
import TicketTable from "./TicketTable.vue"
import TextEditor from "./TextEditor.vue"
import { useRoute,useRouter} from 'vue-router'
import Api from '@/http/modules/index'
import dayjs from "dayjs"
import { useStore } from 'vuex'
import { disabledTimeListsProps } from 'element-plus/es/components/time-picker/src/props/shared'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
    // 用户下拉列表
    'GET/users/enable': usersListApi,
    // 工单详情
    'GET/tickets/{id}':ticketDetailApi,
    // 修改工单
    'PATCH/tickets':patchTicketApi,
    // 评论列表
    'GET/tickets/{id}/comments':commentsApi,
    // 提交评论
    'POST/tickets/comments':submitCommentsApi,
    // 更改状态
    'POST/tickets/change_status':ticketsStatusApi,
    // 更改处理人
    'PATCH/tickets/forward':ticketsForwardApi,
    // 接受并处理
    'PATCH/tickets/{id}/accept':ticketAcceptApi,
    // 拒绝
    'POST/tickets/{id}/reject':ticketRejectApi,
    // 返回修改
    'POST/tickets/{id}/back':ticketBackApi,
    // 返回修改
    'POST/tickets/change_type':ticketTypeChangeApi,
    // 语言列表
    'GET/languages':languagesApi,
    // 行业列表
    'GET/industries':ticketsIndustriesApi,
} = Api
const currentRouteName=ref("")
const store=useStore()
const route=useRoute()
const router=useRouter()
const ticketInfo=ref<any>({})
const languageLists=ref([])
const ticketsIndustries=ref([])
const datalLoading=ref(true)
const userList=ref([])
const getTicketDetail=()=>{
    let params={
        id:route.params.id
    }
    datalLoading.value=true
    ticketDetailApi(params).then((res:any)=>{
        ticketInfo.value=res
        assignedTo.value=res.assignedTo
        datalLoading.value=false
        // if(res.status=='Resolved'&&currentRouteName.value=='SubmitTicketDetail'){
        //     handleOps.value="Resolved"
        // }
    }).catch(()=>{
        datalLoading.value=false
    })
}
const goBack=()=>{
    router.push({name:'TicketLists',query:{tag:currentRouteName.value=='SubmitTicketDetail'?'Submit':currentRouteName.value=='AllTicketDetail'?'All':'Responsible'}})
}
const handleOps=ref("")
const commentText=ref("")
const currentTypeId=ref("")
const isEdit=ref(false)
const setType=()=>{
    currentTypeId.value=ticketInfo.value.typeId
    isEdit.value=true
}
// 修改类型
const modifyType=()=>{
    if(currentTypeId.value==ticketInfo.value.typeId){ //选择的和之前的一样或者选项没有变动
        isEdit.value=false
        return
    }
    let params={
        ticketId:route.params.id,
        typeId:currentTypeId.value
    }
    ticketTypeChangeApi(params).then(()=>{
        ElMessage.success("修改成功")
        ticketInfo.value.typeId=currentTypeId.value
        isEdit.value=false
    })
}
const modifyLoading=ref(false)
const modifyTicket=()=>{
    let {ticketId,description,title,typeId,projectId,ticketProject}=ticketInfo.value
    let params:any={
       ticketId,description,title,typeId,projectId,
    }
    if(ticketProject.options.language){
        params.srcLang=ticketInfo.value.srcLang
        params.trgLang=ticketInfo.value.trgLang
    }
    if(ticketProject.options.industry){
        params.industryId=ticketInfo.value.industryId
    }
    modifyLoading.value=true
    patchTicketApi(params).then((res:any)=>{
        ElMessage.success("修改成功")
        modifyLoading.value=false
        // if(ticketInfo.value.status=='Back'){
        //     router.push({name:"TicketLists",query:{tag:"Submit"}})
        //     return
        // }
        goBack()
    }).catch(()=>{
        modifyLoading.value=false
    })
}
const opsChange=()=>{
    assignedTo.value="",
    showTips.value=false
}
// 评论列表
const commentList=ref([])
const commentListLoading=ref(false)
const getComments=()=>{
    let params={
        id:route.params.id
    }
    commentListLoading.value=true
    commentsApi(params).then((res:any)=>{
        commentList.value=res
        commentListLoading.value=false
    }).catch(()=>{
        commentListLoading.value=false
    })
}
// 发表评论
const submitCommentLoading=ref(false)
const saveComment=()=>{
    if(!commentText.value){
        ElMessage.warning("请添加评论内容")
        return
    }
    let params={
        content:commentText.value,
        ticketId:route.params.id
    }
    submitCommentLoading.value=true
    submitCommentsApi(params).then((res:any)=>{
        submitCommentLoading.value=false
        commentText.value=""
        ElMessage.success("评论保存成功")
        getComments()
    }).catch(()=>{
        submitCommentLoading.value=false
    })
}
// 修改状态
const modifyStatus=(status:string)=>{
    let params={
        status,
        ticketId:route.params.id
    }
    ticketsStatusApi(params).then((res:any)=>{
        ElMessage.success("操作成功")
        // goBack()
        getTicketDetail()        
    })
}
// 更改处理人
const assignedTo=ref("")
const showTips=ref(false)
const forwardHandle=()=>{
    if(!assignedTo.value){
        ElMessage.warning("请选择处理人")
        return
    }
    if(assignedTo.value==ticketInfo.value.userId){
        showTips.value=true
        return
    }
    let params={
        assignedTo:assignedTo.value,
        ticketId:route.params.id
    }
    showTips.value=false
    ticketsForwardApi(params).then(()=>{
        ElMessage.success("更改成功")
        goBack()
    })
}
// 接受并处理
const acceptHandle=()=>{ 
    let params={
        id:route.params.id
    }   
    ticketAcceptApi(params).then(()=>{
        ElMessage.success("操作成功")
        ticketInfo.value.status='Processed'
    })
}
// 拒绝
const rejectHandle=()=>{
    let params={
        id:route.params.id
    }
    ticketRejectApi(params).then(()=>{
        ElMessage.success("操作成功")
        ticketInfo.value.status='Reject'
    })
}
//退回修改
const backHandle=()=>{
    let params={
        id:route.params.id
    }
    ticketBackApi(params).then(()=>{
        ElMessage.success("操作成功")
        ticketInfo.value.status='Back'
    })
}
const filterType=()=>{
    let {typeId,ticketTypes}=ticketInfo.value
    let res=ticketTypes.find((el:any)=>el.typeId==typeId)
    return res?res.name:""
}
// 我负责的工单详情，行业，语言修改时直接保存修改
const directModify=()=>{
    if(currentRouteName.value=='ResponsibleTicketDetail'){
        modifyTicket()
    }
}

// 禁用规则
const disabledRule=()=>{
    let {status}=ticketInfo.value
    if(currentRouteName.value=='SubmitTicketDetail'){ //提单人进入详情页
       if(status!='New'&&status!='Back'){
           return true
       } 
    }
    if(currentRouteName.value=='ResponsibleTicketDetail'){ //处理人进入详情页
       if(status=='Resolved'){
           return true
       } 
    }
    return currentRouteName.value=='AllTicketDetail'? true :false //全部工单进入详情页

}
const openAttachment=(e:any)=>{
    e.preventDefault()
    if(e.target.tagName === 'A'){
        window.open(e.target.href,"_blank")
    }
}
const remarkHTML=(remark:any)=> {
  if (remark) {
    return remark.replace(/\n|\r\n/g, '<br>').replace(/ /g, '  ')
  }
  return ''
}
onMounted(()=>{
    currentRouteName.value=router.currentRoute.value.name as string
    getTicketDetail()
    getComments()
    usersListApi().then((res:any)=>{
        userList.value=res
    })
    languagesApi().then((res:any)=>{
        languageLists.value=res
    })
    ticketsIndustriesApi().then((res:any)=>{
        ticketsIndustries.value=res
    })

    // document.
})

return (_ctx: any,_cache: any) => {
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (!datalLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            onClick: goBack,
            style: {"padding-top":"5px","cursor":"pointer"}
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            (currentRouteName.value=='SubmitTicketDetail')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "我提交的"))
              : _createCommentVNode("", true),
            (currentRouteName.value=='ResponsibleTicketDetail')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "我负责的"))
              : _createCommentVNode("", true),
            (currentRouteName.value=='AllTicketDetail')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "全部工单"))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_9, "ID " + _toDisplayString(ticketInfo.value.ticketId), 1),
            (!datalLoading.value&&ticketInfo.value.typeId&&!isEdit.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  class: _normalizeClass(`${disabledRule()||currentRouteName.value=='AllTicketDetail'?'':'type-edit' } d-flex align-items-center text-color`),
                  style: {"line-height":"16px"}
                }, [
                  _createTextVNode(_toDisplayString(filterType()) + " ", 1),
                  (ticketInfo.value.status&&ticketInfo.value.status!='Resolved')
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        style: {"cursor":"pointer"},
                        onClick: setType,
                        class: "ml-10 edit-icon",
                        size: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Edit)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (isEdit.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    modelValue: currentTypeId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTypeId).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketInfo.value.ticketTypes, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.typeId,
                          value: item.typeId,
                          label: item.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    onClick: modifyType,
                    class: "ml-10",
                    size: "small",
                    icon: _unref(Check),
                    circle: ""
                  }, null, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (isEdit.value=false)),
                    class: "ml-10",
                    size: "small",
                    icon: _unref(Close),
                    circle: ""
                  }, null, 8, ["icon"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (ticketInfo.value.ticketProject&&(ticketInfo.value.ticketProject.options.language||ticketInfo.value.ticketProject.options.industry))
          ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
          : _createCommentVNode("", true),
        (ticketInfo.value.ticketProject&&(ticketInfo.value.ticketProject.options.language||ticketInfo.value.ticketProject.options.industry))
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              inline: "",
              model: ticketInfo.value
            }, {
              default: _withCtx(() => [
                (ticketInfo.value.ticketProject&&ticketInfo.value.ticketProject.options.industry)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "所属行业",
                      prop: "industryId",
                      rules: [{ required: true, message: '请选择所属行业' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          onChange: directModify,
                          disabled: disabledRule(),
                          filterable: "",
                          modelValue: ticketInfo.value.industryId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ticketInfo.value.industryId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketsIndustries.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.industryId,
                                label: item.name,
                                value: item.industryId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (ticketInfo.value.ticketProject&&ticketInfo.value.ticketProject.options.language)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "源语言",
                      prop: "srcLang",
                      rules: [{ required: true, message: '请选择源语言' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          onChange: directModify,
                          disabled: disabledRule(),
                          modelValue: ticketInfo.value.srcLang,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ticketInfo.value.srcLang) = $event)),
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageLists.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                disabled: item.code==ticketInfo.value.trgLang,
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["disabled", "label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (ticketInfo.value.ticketProject&&ticketInfo.value.ticketProject.options.language)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "目标语言",
                      prop: "trgLang",
                      rules: [{ required: false, message: '请选择目标语言' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          onChange: directModify,
                          disabled: disabledRule(),
                          modelValue: ticketInfo.value.trgLang,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ticketInfo.value.trgLang) = $event)),
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageLists.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                disabled: item.code==ticketInfo.value.srcLang,
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["disabled", "label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider),
        (datalLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_el_icon, {
                size: "25",
                color: "#409eff",
                class: "is-loading"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (currentRouteName.value=='SubmitTicketDetail'&&!datalLoading.value)
                ? (_openBlock(), _createBlock(TextEditor, {
                    key: 0,
                    status: ticketInfo.value.status,
                    height: 300,
                    isCreat: false,
                    onSetData: _cache[5] || (_cache[5] = val=>ticketInfo.value.description=val),
                    description: ticketInfo.value.description
                  }, null, 8, ["status", "description"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      id: "edit-html",
                      class: "ed-html",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (openAttachment($event))),
                      innerHTML: ticketInfo.value.description
                    }, null, 8, _hoisted_13)
                  ]))
            ], 64)),
        _createVNode(_component_el_divider),
        (ticketInfo.value.status&&ticketInfo.value.status=='New'&&currentRouteName.value=='SubmitTicketDetail')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              loading: modifyLoading.value,
              type: "primary",
              onClick: modifyTicket
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              (currentRouteName.value!='SubmitTicketDetail')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, " 创建人 " + _toDisplayString(ticketInfo.value.user?ticketInfo.value.user.username:""), 1),
                      _createElementVNode("div", {
                        style: {"line-height":"32px"},
                        class: _normalizeClass({'tip-message':showTips.value,'ml-30':true})
                      }, [
                        _hoisted_18,
                        _createVNode(_component_el_select, {
                          disabled: disabledRule(),
                          filterable: "",
                          modelValue: assignedTo.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((assignedTo).value = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.userId,
                                label: `${item.realName} (${item.username})`,
                                value: item.userId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"]),
                        (!disabledRule())
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "ml-10",
                              disabled: disabledRule(),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (forwardHandle()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    (currentRouteName.value=='ResponsibleTicketDetail')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_button, {
                            plain: "",
                            type: ticketInfo.value.status&&ticketInfo.value.status=='Processed'?'primary':'default',
                            disabled: ticketInfo.value.status&&ticketInfo.value.status=='Resolved',
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (acceptHandle()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }, 8, ["type", "disabled"]),
                          _createVNode(_component_el_button, {
                            plain: "",
                            type: ticketInfo.value.status&&ticketInfo.value.status=='Back'?'primary':'default',
                            disabled: ticketInfo.value.status&&ticketInfo.value.status=='Resolved',
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (backHandle()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["type", "disabled"]),
                          _createVNode(_component_el_button, {
                            plain: "",
                            type: ticketInfo.value.status&&ticketInfo.value.status=='Reject'?'primary':'default',
                            disabled: ticketInfo.value.status&&ticketInfo.value.status=='Resolved',
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (rejectHandle()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }, 8, ["type", "disabled"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (currentRouteName.value=='SubmitTicketDetail')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({'tip-message':showTips.value})
                  }, [
                    (ticketInfo.value.status&&ticketInfo.value.status=='Back')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_el_button, {
                            loading: modifyLoading.value,
                            onClick: modifyTicket
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_25, "处理人 " + _toDisplayString(ticketInfo.value.assignedUser?ticketInfo.value.assignedUser.username:ticketInfo.value.user?ticketInfo.value.user.username:""), 1),
                          _createVNode(_component_el_button, {
                            plain: "",
                            type: ticketInfo.value.status&&ticketInfo.value.status=='Resolved'?'primary':'default',
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (modifyStatus('Resolved')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createVNode(_component_el_button, {
                            plain: "",
                            disabled: ticketInfo.value.status&&ticketInfo.value.status=='Resolved',
                            type: ticketInfo.value.status&&ticketInfo.value.status=='Unresolved'?'primary':'default',
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (modifyStatus('Unresolved')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          }, 8, ["disabled", "type"])
                        ], 64))
                  ], 2))
                : _createCommentVNode("", true),
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_input, {
                      style: {"flex":"1"},
                      type: "textarea",
                      disabled: submitCommentLoading.value,
                      modelValue: commentText.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((commentText).value = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_el_button, {
                      class: "ml-10",
                      loading: submitCommentLoading.value,
                      onClick: saveComment
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                (commentList.value.length)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
                      key: 0,
                      height: "300px"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentList.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"font-size":"14px"},
                            key: item.id,
                            class: "mb-10"
                          }, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("strong", null, _toDisplayString(item.username), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(dayjs)(item.createdAt).format("YYYY-MM-DD HH:mm")), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "comment-text",
                              innerHTML: remarkHTML(item.content)
                            }, null, 8, _hoisted_35)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })), [
                      [_directive_loading, commentListLoading.value]
                    ])
                  : _createCommentVNode("", true)
              ])
            ], 64))
      ]))
    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, null, 512)), [
        [_directive_loading, true]
      ])
}
}

})